module.exports = __webpack_public_path__ + "static/media/logo.ba05c033.svg";